
import type {
  ThreadResponse,
  EvaluationResponse,
  ThreadScorecardResponse,
  BatchResponse,
} from "../../gen/models";
import { EvaluationDrawer } from "../EvaluationDrawer";
import { SimulatorDrawer } from "../SimulatorDrawer";

interface ThreadDetailOverlaysProps {
  thread: ThreadResponse | null;
  scorecard: ThreadScorecardResponse | null;
  evaluations?: EvaluationResponse[];
  isEvalDrawerOpen: boolean;
  selectedEvaluation: EvaluationResponse | null;
  evalDrawerMessageId: string | null;
  evalDrawerRunId: string | null;
  evalDrawerIsHumanMode: boolean;
  isSimulatorOpen: boolean;
  simulatorTurnId?: string;
  simulatorInquiry?: string;
  simulatorBaseline?: string;
  onCloseEvalDrawer: () => void;
  onCloseSimulator: () => void;
  onReviewSubmitted: () => void;
  activeBatch?: BatchResponse | null;
  activeBatches?: BatchResponse[];
  allBatches?: BatchResponse[];
  onRequireActiveBatch?: (callback?: (batchId: string) => void) => void;
  onOpenBatchAssignModal?: (evals?: EvaluationResponse[]) => void;
  onAssignDirectToActiveBatch?: (evalIds: string[]) => Promise<void>;
}

export function ThreadDetailOverlays({
  thread,
  scorecard,
  evaluations = [],
  isEvalDrawerOpen,
  selectedEvaluation,
  evalDrawerMessageId,
  evalDrawerRunId,
  evalDrawerIsHumanMode,
  isSimulatorOpen,
  simulatorTurnId,
  simulatorInquiry,
  simulatorBaseline,
  onCloseEvalDrawer,
  onCloseSimulator,
  onReviewSubmitted,
  activeBatch,
  activeBatches,
  allBatches,
  onRequireActiveBatch,
  onOpenBatchAssignModal,
  onAssignDirectToActiveBatch,
}: ThreadDetailOverlaysProps) {
  if (!thread) return null;

  return (
    <>
      {/* Evaluation Details Drawer */}
      <EvaluationDrawer
        isOpen={isEvalDrawerOpen}
        onClose={onCloseEvalDrawer}
        threadId={thread.id}
        evaluation={selectedEvaluation}
        evaluations={evaluations}
        scorecard={scorecard}
        messageId={evalDrawerMessageId}
        runId={evalDrawerRunId}
        initialHumanReviewMode={evalDrawerIsHumanMode}
        onReviewSubmitted={onReviewSubmitted}
        activeBatch={activeBatch}
        activeBatches={activeBatches}
        allBatches={allBatches}
        onRequireActiveBatch={onRequireActiveBatch}
        onOpenBatchAssignModal={onOpenBatchAssignModal}
        onAssignDirectToActiveBatch={onAssignDirectToActiveBatch}
      />

      {/* Pre-Merge Simulator Drawer */}
      <SimulatorDrawer
        isOpen={isSimulatorOpen}
        onClose={onCloseSimulator}
        threadId={thread.id}
        targetTurnId={simulatorTurnId}
        defaultAgentType={thread.agent_type}
        initialInquiry={simulatorInquiry}
        initialBaselineContent={simulatorBaseline}
      />
    </>
  );
}
